import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=307ab74e&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=ts"
export * from "./VerificationCode.vue?vue&type=script&lang=ts"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=307ab74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307ab74e",
  null
  
)

export default component.exports